/* eslint-disable jsx-a11y/img-redundant-alt */

import React from "react";
import UserContext from "../UserContext";
import VideoPlayer from "./VideoPlayer";

export default function ExplorePost({ data = {} }) {
  const { mode } = React.useContext(UserContext);
  // setting the theme
  const [dark, setDark] = React.useState(false);

  React.useEffect(() => {
    let darkmode = localStorage.getItem("darkmode")
      ? JSON.parse(localStorage.getItem("darkmode"))
      : false;
    setDark(darkmode);
  }, [mode]);

  return (
    <div className="mt-4">
      <div className={dark ? "card darkmode" : "card"}>
        <div className="card-block">
          <div className="w-full h-1/2  feed--image flex justify-center all-container">
            {data.url && (
              <div style={{ width: "100%" }}>
                {/* <video
                  width="100%"
                  height="500"
                  controls
                  poster={data.thumbnail}
                >
                  <source src={data.url} />
                </video> */}
                <VideoPlayer
                  source={data.url}
                  width={"100%"}
                  style={{ height: "500px" }}
                  videoId={`vidId${Math.random()}`}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
